<template>
  <div class="page-container">
    <div class="query-title">制票通知单查询</div>

    <div class="content">
      <QueryParams ref="QueryParams" :search-field="searchField" @search="queryData" />
      <div class="table-container">
        <Table-filter
          title="明细"
          :rt-columns="rtColumns1"
          :lt-columns="ltColumns1"
          :grid-columns="gridOptions.columns"
          :count-data="countFileds"
          :all-options="allOptions"
          :pagination="pagination"
          @pagination-change="handleTablePaginationChange"
          @confirm="tableConfigConfirm"
        >
          <template #button>
            <table-button name="export" tip="生成" @click="printDialog" />
            <table-button name="export" tip="导出" @click="exportExcel" />
          </template>
          <vxe-grid
            ref="xTable"
            v-loading="loading"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            height="300"
            max-height="500"
            align="center"
            size="mini"
            show-overflow
            :checkbox-config="{ highlight: true }"
            :radio-config="{ highlight: true }"
            :sort-config="{ multiple: true }"
            :empty-render="{name: 'NotData'}"
            :filter-config="{ remote: true }"
            :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptions.columns"
            :data="gridOptions.data"
            :row-class-name="rowClassName"
            @filter-change="filterChangeEvt"
          >
            <template #red_rush_id="{ row }">
              <el-link type="primary" @click="toDetail(row)">
                {{ row.red_rush_id }}
              </el-link>
            </template>
          </vxe-grid>
        </Table-filter>
      </div>
    </div>

    <table-custom-filter ref="CustomFilter" :current-filter-field="currentFilterField" @confirm="customeFilter" />

    <el-dialog
      v-dialogDrag
      :visible.sync="showDialog"
      title="浏览制票通知单"
      width="70%"
      top="5vh"
    >
      <iframe :src="url" frameborder="0" style="width: 100%;height: 600px" />
      <div slot="footer">
        <el-button
          type="default"
          icon="el-icon-circle-close"
          size="small"
          @click="showDialog = false"
        >取消</el-button>
        <el-button
          type="primary"
          icon="el-icon-circle-check"
          size="small"
          @click="confirmPrint"
        >确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { apiGetRedRushList, printInvoice } from '@/api/sap/make-invoice-sap'
import tableMixins from '@/utils/tableMixins'
import pageConfig from '../config/redOrderList'
import { frontExport, concurrencyReq } from '@/utils/frontExport'
import { hexToBytes } from '@/utils/frontExport'

export default {
  mixins: [tableMixins],
  data() {
    return {
      loading: false,
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      showDialog: false,
      url: '',
      gridOptions: {
        columns: [
          { type: 'radio', field: 'radio', title: '', width: 50 }
        ],
        data: []
      },
      searchField: {},
      isSetFilter: false
    }
  },
  created() {
    this.initPage(pageConfig)
  },
  methods: {
    toDetail(row) {
      this.$router.push({
        path: '/wly/make-ticket-notice/red-order-detail',
        query: {
          id: row.red_rush_id
        }
      })
    },
    confirmPrint() {
      this.$confirm('确认已经打印此制票通知单！', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      }).then(res => {
        const data = this.$refs.xTable.getRadioRecord()
        printInvoice({
          user_bp: this.$store.getters.role.USER_BP,
          invo_infoid: data.map(v => v.invo_infoid),
          mode: 'X'
        }).then(res => {
          this.showDialog = false
          this.queryData()
        })
      })
    },
    printDialog() {
      const data = this.$refs.xTable.getRadioRecord()
      if (!data.red_rush_id) return this.$message.warning('请选择有效数据！')
      // this.$emit('changeActive', 'checkeOrder', '', data)redOrderData
      this.$router.push({
        path: '/wly/make-ticket-notice/red-order-data',
        query: {
          id: row.red_rush_id
        }
      })
    },
    async queryData(page, ranges) {
      if (page === 1) {
        this.pagination.page = page
        if (ranges) {
          // 保存 查询组件的查询参数
          this.ranges = ranges
          this.handleRanges(ranges)
        }
        this.isSetFilter = false
      }
      const params = {
        user_bp: this.$store.getters.role.USER_BP,
        role: this.$store.getters.role.ROLE,
        ...this.allConditions,
        ...this.pagination,
        is_result: 1,
        sort: this.sortData.concat(this.tableSort)
      }

      this.loading = true
      try {
        const { data, total, calculation, field } = await apiGetRedRushList(params)
        if (data.length === 0 && (total - 0)) {
          this.queryData(1, ranges)
          return
        }
        this.pagination.totalCount = total - 0
        this.calculation = this.filtercalculation(calculation)
        // 更新计算值
        this.updateCount()
        if (this.showHeader) {
          this.gridOptions.data = this.tableCountData.concat(data)
        } else {
          this.gridOptions.data = data.concat(this.tableCountData)
        }
        this.allOptions = this.filterAllOptions(field)
        this.setFilter()
      } catch (e) {
        //
      }
      this.loading = false
    },
    async exportExcel() {
      const params = {
        user_bp: this.$store.getters.role.USER_BP,
        ...this.allConditions
      }
      const data = await concurrencyReq(this.pagination.totalCount, params, apiGetRedRushList)
      frontExport(this.gridOptions.columns, data, '制票通知单')
    },
    handleTablePaginationChange(pages) {
      Object.assign(this.pagination, pages)
      this.queryData()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/invoice-manage/components/redOrderList.vue